import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import Footer from "../../Footer";
import { useParams } from "react-router-dom";

function EditCategory(props) {
  const { token } = isAutheticated();
  const [categoryName, setCategoryName] = useState("");
  const { catagoryId } = useParams();
  console.log("vvvvvv", catagoryId)

  const [loading, setLoading] = useState(false);
  const [apiLoading, setApiLoading] = useState(true);
  const [nameLen, setNameLen] = useState(50);
  const wordLimit = 50;
  const history = useHistory();

  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= wordLimit) {
      setCategoryName(value);
      setNameLen(wordLimit - value.length);
    }
  };

  const fetchCategory = async () => {
    try {
      const res = await axios.get(
        `${API}/api/category/${catagoryId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log("ddddddddd", res.data.data)

      setCategoryName(res.data.data?.category);
      setNameLen(wordLimit - res.data.data?.category?.length);
    } catch (err) {
      const message =
        err?.response?.data?.message || "Failed to fetch category.";
      swal({ title: message, icon: "error", button: "Close" });
    } finally {
      setApiLoading(false);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!categoryName.trim()) {
      swal({ title: "Enter Category Name", icon: "warning", button: "Close" });
      return;
    }

    setLoading(true);
    try {
      const res = await axios.patch(
        `${API}/api/category/${catagoryId}`,
        { category: categoryName.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      swal({
        title: res.data.message || "Category updated successfully",
        icon: "success",
        button: "OK",
      }).then(() => history.push("/comcatagory"));
    } catch (err) {
      const message =
        err?.response?.data?.message || "Failed to update category.";
      swal({ title: message, icon: "error", button: "Close" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">OTT Shop - Categories</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">SoComOTT</Link>
                    </li>
                    <li className="breadcrumb-item">OTT Shop - Categories</li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  {apiLoading ? (
                    <div className="text-center my-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="col-md-12 col-lg-6">
                      <h1 className="text-left head-small">Edit Category</h1>
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label className="label-100">Category Name</label>
                          <input
                            type="text"
                            className="form-control input-field"
                            value={categoryName}
                            onChange={handleChange}
                          />
                          <small className="text-muted">
                            Remaining characters: {nameLen}
                          </small>
                        </div>
                        <div className="form-group mt-3">
                          <button
                            type="submit"
                            className="btn btn-success"
                            disabled={loading}
                          >
                            {loading ? (
                              <div className="spinner-border spinner-border-sm text-light">
                                <span className="sr-only">Loading...</span>
                              </div>
                            ) : (
                              "Save"
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EditCategory;
